"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLocahostLogin = void 0;
const isLocahostLogin = () => {
    const { pathname } = window.location;
    return isLocahost() && /\/login/.test(pathname);
};
exports.isLocahostLogin = isLocahostLogin;
const isLocahost = () => {
    const { hostname } = window.location;
    return hostname === 'localhost';
};
//# sourceMappingURL=utils.js.map